var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeypad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#5D6B72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "keypad",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 18,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72955 4.60676H16.7722V7.09127H6.72955V4.60676Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9387 9.21522H9.44935V11.6997H6.9387V9.21522Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44935 12.8299H6.9387V15.3144H9.44935V12.8299Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44935 16.4445H6.9387V18.929H9.44935V16.4445Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1157 9.21522H10.605V11.6997H13.1157V9.21522Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1157 12.8299H10.605V15.3144H13.1157V12.8299Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1157 16.4445H10.605V18.929H13.1157V16.4445Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7819 9.21522H14.2713V11.6997H16.7819V9.21522Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7819 12.8299H14.2713V15.3144H16.7819V12.8299Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7819 16.4445H14.2713V18.929H16.7819V16.4445Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6886 1.00098H5.95958C4.32505 1.00098 3 2.32603 3 3.96056V20.0414C3 21.6759 4.32505 23.001 5.95958 23.001H17.6886C19.3232 23.001 20.6482 21.6759 20.6482 20.0414V3.96056C20.6482 2.32602 19.3232 1.00098 17.6886 1.00098ZM4.97305 3.96056C4.97305 3.41572 5.41474 2.97403 5.95958 2.97403H17.6886C18.2335 2.97403 18.6752 3.41572 18.6752 3.96056V20.0414C18.6752 20.5862 18.2335 21.0279 17.6886 21.0279H5.95958C5.41474 21.0279 4.97305 20.5862 4.97305 20.0414V3.96056Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#keypad)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.000976562,
    width: 24,
    height: 24
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeypad);
export default __webpack_public_path__ + "static/media/keypad.ffbee072.svg";
export { ForwardRef as ReactComponent };